import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class CoinService {
  constructor(public http: HttpClient) {}

  public getAll(id: number, filter: any = []) {
    return this.http.post<any>(`customers/coin_historylist/` + id, filter);
  }

  getById(id: number) {
    return this.http.get(`announcement/view/` + id);
  }

  insert(merchant: any) {
    return this.http.post(`announcement/add`, merchant);
  }

  update(merchant: any) {
    return this.http.post(`announcement/update`, merchant);
  }

  delete(id: number) {
    return this.http.get(`announcement/delete/` + id);
  }
}
